import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown, FaUpload, FaTimesCircle } from "react-icons/fa";
import { countryList } from '../../utils/countryData';
import { stldigitalCountryList } from '../../utils/stldigitalCountryData';
import { getRegionsForCountry } from '../../utils/regionData';
import { getStlDigitalRegionsForCountry } from '../../utils/stldigitalRegionData';

// Reusable Bank Fields Component extracted outside to prevent re-renders losing focus
const BankFields = ({ vendorData, handleVendorChange, isDisabled, vendorOnboardInfo, isBankMandatory }) => {
    // Dropdown States specific to this step (Bank Details) - Moved inside BankFields
    const [isBankCountryDropdownOpen, setIsBankCountryDropdownOpen] = useState(false);
    const [bankCountrySearchTerm, setBankCountrySearchTerm] = useState('');
    const bankCountryDropdownRef = useRef(null);

    const [isBankRegionDropdownOpen, setIsBankRegionDropdownOpen] = useState(false);
    const [bankRegionSearchTerm, setBankRegionSearchTerm] = useState('');
    const bankRegionDropdownRef = useRef(null);

    // Context Helpers
    const isStlDigital = vendorOnboardInfo?.company &&
        (vendorOnboardInfo.company.trim().replace('-', '').toLowerCase() === 'stldigital' ||
            vendorOnboardInfo.company.trim().toLowerCase() === 'stl-digital');

    // Click outside handler for dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (bankCountryDropdownRef.current && !bankCountryDropdownRef.current.contains(event.target)) {
                setIsBankCountryDropdownOpen(false);
            }
            if (bankRegionDropdownRef.current && !bankRegionDropdownRef.current.contains(event.target)) {
                setIsBankRegionDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div style={{ marginTop: '8px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {/* Row 1: Bank Country & Bank Region DROPDOWNS */}
            <div ref={bankCountryDropdownRef}>
                <span className="input-label">Bank Country{isBankMandatory || isStlDigital ? '*' : ' (Optional)'}</span>
                <div style={{ position: 'relative', marginTop: '4px' }}>
                    <div
                        onClick={() => {
                            console.log(isDisabled);
                            if (!isDisabled) {
                                setIsBankCountryDropdownOpen(!isBankCountryDropdownOpen);
                                if (!isBankCountryDropdownOpen) setBankCountrySearchTerm('');
                            }
                        }}
                        style={{
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            width: '100%',
                            backgroundColor: isDisabled ? '#f3f4f6' : '#fff',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            minHeight: '38px'
                        }}
                    >
                        <span style={{ color: vendorData.bank_country ? '#000' : '#888' }}>
                            {vendorData.bank_country ? vendorData.bank_country : "Select Country"}
                        </span>
                        <FaChevronDown style={{ color: 'gray', fontSize: '12px' }} />
                    </div>
                    {isBankCountryDropdownOpen && (
                        <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            width: '100%',
                            maxHeight: '250px',
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000,
                            marginTop: '4px',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                                <input
                                    type="text"
                                    placeholder="Search country..."
                                    value={bankCountrySearchTerm}
                                    onChange={(e) => setBankCountrySearchTerm(e.target.value)}
                                    autoFocus
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', outline: 'none' }}
                                />
                            </div>
                            <div className="dropdown-scrollbar" style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                {(isStlDigital ? stldigitalCountryList : countryList)
                                    .filter(c => c.name.toLowerCase().includes(bankCountrySearchTerm.toLowerCase()) || c.code.toLowerCase().includes(bankCountrySearchTerm.toLowerCase()))
                                    .map((country) => (
                                        <div
                                            key={country.code}
                                            onClick={() => {
                                                handleVendorChange({ target: { name: 'bank_country', value: country.code } });
                                                setIsBankCountryDropdownOpen(false);
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #f7f7f7',
                                                backgroundColor: vendorData.bank_country === country.code ? '#eef2ff' : 'transparent',
                                                color: vendorData.bank_country === country.code ? '#4f46e5' : '#333'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = vendorData.bank_country === country.code ? '#eef2ff' : 'transparent'}
                                        >
                                            <span style={{ fontWeight: 500, marginRight: '8px' }}>{country.code}</span>
                                            {country.name}
                                        </div>
                                    ))}
                                {(isStlDigital ? stldigitalCountryList : countryList).filter(c => c.name.toLowerCase().includes(bankCountrySearchTerm.toLowerCase()) || c.code.toLowerCase().includes(bankCountrySearchTerm.toLowerCase())).length === 0 && (
                                    <div style={{ padding: '12px', color: '#888', textAlign: 'center' }}>No countries found</div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div ref={bankRegionDropdownRef}>
                <span className="input-label">Bank Region{isBankMandatory ? '*' : ' (Optional)'}</span>
                <div style={{ position: 'relative', marginTop: '4px' }}>
                    <div
                        onClick={() => {
                            if (!isDisabled && vendorData.bank_country) {
                                setIsBankRegionDropdownOpen(!isBankRegionDropdownOpen);
                                if (!isBankRegionDropdownOpen) setBankRegionSearchTerm('');
                            }
                        }}
                        style={{
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            width: '100%',
                            backgroundColor: isDisabled || !vendorData.bank_country ? '#f3f4f6' : '#fff',
                            cursor: isDisabled || !vendorData.bank_country ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            minHeight: '38px'
                        }}
                    >
                        <span style={{ color: vendorData.bank_state ? '#000' : '#888' }}>
                            {vendorData.bank_state || (vendorData.bank_country ? "Select Region" : "Select Region")}
                        </span>
                        <FaChevronDown style={{ color: 'gray', fontSize: '12px' }} />
                    </div>
                    {isBankRegionDropdownOpen && vendorData.bank_country && (() => {
                        const availableRegions = isStlDigital
                            ? getStlDigitalRegionsForCountry(vendorData.bank_country)
                            : getRegionsForCountry(vendorData.bank_country);
                        const filteredRegions = availableRegions.filter(r => r.region.toLowerCase().includes(bankRegionSearchTerm.toLowerCase()) || r.description.toLowerCase().includes(bankRegionSearchTerm.toLowerCase()));
                        return (
                            <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                width: '100%',
                                maxHeight: '160px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                zIndex: 1000,
                                marginTop: '4px',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <div style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                                    <input
                                        type="text"
                                        placeholder="Search region..."
                                        value={bankRegionSearchTerm}
                                        onChange={(e) => setBankRegionSearchTerm(e.target.value)}
                                        autoFocus
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', outline: 'none' }}
                                    />
                                </div>
                                <div className="dropdown-scrollbar" style={{ overflowY: 'auto', maxHeight: '150px' }}>
                                    {isStlDigital && (
                                        <div
                                            onClick={() => {
                                                handleVendorChange({ target: { name: 'bank_state', value: '' } });
                                                setIsBankRegionDropdownOpen(false);
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #f7f7f7',
                                                color: '#2c2a2aff',
                                                fontStyle: 'italic'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            None
                                        </div>
                                    )}
                                    {filteredRegions.map((region) => (
                                        <div
                                            key={`${region.countryCode}-${region.region}`}
                                            onClick={() => {
                                                handleVendorChange({ target: { name: 'bank_state', value: region.region } });
                                                setIsBankRegionDropdownOpen(false);
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #f7f7f7',
                                                backgroundColor: vendorData.bank_state === region.region ? '#eef2ff' : 'transparent',
                                                color: vendorData.bank_state === region.region ? '#4f46e5' : '#333'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = vendorData.bank_state === region.region ? '#eef2ff' : 'transparent'}
                                        >
                                            <span style={{ fontWeight: 500, marginRight: '8px' }}>{region.region}</span>
                                            {region.description}
                                        </div>
                                    ))}
                                    {filteredRegions.length === 0 && (
                                        <div style={{ padding: '12px', color: '#888', textAlign: 'center' }}>No regions found</div>
                                    )}
                                </div>
                            </div>
                        );
                    })()}
                </div>
            </div>
            {/* Row 1: Account & IFSC */}
            <div>
                <span className="input-label">Account Number*</span>
                <input
                    type="text"
                    name="account_number"
                    placeholder="Account Number"
                    value={vendorData.account_number}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>
            <div>
                <span className="input-label">
                    {vendorData.bank_country === 'IN'
                        ? 'IFSC Code*'
                        : (vendorData.bank_country ? 'SWIFT Code*' : 'IFSC/SWIFT Code*')}
                </span>
                <input
                    type="text"
                    name="ifsc_code"
                    placeholder={vendorData.bank_country === 'IN'
                        ? 'IFSC Code'
                        : (vendorData.bank_country ? 'SWIFT Code' : 'IFSC Code/Swift Code')}
                    value={vendorData.ifsc_code}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>

            {/* Row 2: Account Holder Name (Full Width) */}
            <div style={{ gridColumn: '1 / -1' }}>
                <span className="input-label">Account Holder Name*</span>
                <input
                    type="text"
                    name="account_holder_name"
                    placeholder="Account Holder Name"
                    value={vendorData.account_holder_name}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>

            {/* Row 3: IBAN (Full Width) */}
            {vendorData.country && vendorData.country !== 'IN' && (
                <div style={{ gridColumn: '1 / -1' }}>
                    <span className="input-label">IBAN Number (Optional)</span>
                    <input
                        type="text"
                        name="iban_number"
                        placeholder="IBAN Number"
                        value={vendorData.iban_number}
                        onChange={handleVendorChange}
                        disabled={isDisabled}
                        style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                    />
                </div>
            )}

            {/* Row 4: Bank Name & Bank Address */}
            <div>
                <span className="input-label">Bank Name{isBankMandatory || isStlDigital ? '*' : ' (Optional)'}</span>
                <input
                    type="text"
                    name="bank_name"
                    placeholder="Bank Name"
                    value={vendorData.bank_name}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    maxLength={isStlDigital ? 60 : undefined}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>
            <div>
                <span className="input-label">Bank Address{isBankMandatory || isStlDigital ? '*' : ' (Optional)'}</span>
                <input
                    type="text"
                    name="bank_address"
                    placeholder="Bank Address"
                    value={vendorData.bank_address}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>

            {/* STL-DIGITAL Specific: Bank Key & Bank Account Name */}
            {isStlDigital && (
                <>
                    {vendorData.bank_country === 'IN' && (
                        <div>
                            <span className="input-label">SWIFT Code (Optional)</span>
                            <input
                                type="text"
                                name="bank_control_key"
                                placeholder="SWIFT Code"
                                value={vendorData.bank_control_key || ''}
                                onChange={handleVendorChange}
                                disabled={isDisabled}
                                style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                            />
                        </div>
                    )}
                    <div>
                        <span className="input-label">Bank Account Type (Opt)</span>
                        <input
                            type="text"
                            name="bank_account_name"
                            placeholder="Bank Account Type"
                            value={vendorData.bank_account_name || ''}
                            onChange={handleVendorChange}
                            disabled={isDisabled}
                            style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                        />
                    </div>
                </>
            )}

            {/* Row 5: Bank City & Bank Branch */}
            <div>
                <span className="input-label">Bank City{isBankMandatory || isStlDigital ? '*' : ' (Optional)'}</span>
                <input
                    type="text"
                    name="bank_city"
                    placeholder="Bank City"
                    value={vendorData.bank_city}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>
            <div>
                <span className="input-label">Bank Branch{isBankMandatory && !isStlDigital ? '*' : ' (Optional)'}</span>
                <input
                    type="text"
                    name="bank_branch"
                    placeholder="Bank Branch"
                    value={vendorData.bank_branch}
                    onChange={handleVendorChange}
                    disabled={isDisabled}
                    style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', marginTop: '4px' }}
                />
            </div>


        </div>
    );
};

const Step2_Bank = ({
    vendorData,
    handleVendorChange,
    isDisabled,
    vendorOnboardInfo,
    uploaded,
    fileNames,
    handleFileChange,
    handleRemoveFile,
    passbookRef,
    chequeRef
}) => {
    // Logic for mandatory/optional labels based on Organization Country
    // If Org Country is IN or not selected, Bank fields are Mandatory.
    const isBankMandatory = (vendorData.country === 'IN' || !vendorData.country);

    //     /* ------------------ VERIFIED LOGIC ADDED ------------------ */

    const [verificationState, setVerificationState] = useState({
        passbook: {
            ocrSuccess: false,
            userModified: false,
            manuallyVerified: false
        },
        cheque: {
            ocrSuccess: false,
            userModified: false,
            manuallyVerified: false
        }
    });

    const [ocrSnapshot, setOcrSnapshot] = useState(null);

    const handleBankFieldChange = (e) => {

        handleVendorChange(e);

        if (ocrSnapshot) {

            const { name, value } = e.target;

            if (ocrSnapshot[name] !== value) {

                setVerificationState(prev => ({
                    ...prev,
                    passbook: { ...prev.passbook, userModified: true },
                    cheque: { ...prev.cheque, userModified: true }
                }));

            }
        }
    };

    const handleOCRResult = (docType, ocrData) => {

        if (ocrData?.success) {

            setOcrSnapshot(ocrData.data);

            Object.keys(ocrData.data).forEach(key => {

                handleVendorChange({
                    target: {
                        name: key,
                        value: ocrData.data[key]
                    }
                });

            });

            setVerificationState(prev => ({
                ...prev,
                [docType]: {
                    ...prev[docType],
                    ocrSuccess: true
                }
            }));

        }
    };

    const getVerificationStatus = (docType) => {
        const doc = verificationState[docType];

        // Define the mandatory fields required for a "Verified" status
        const requiredFields = ['account_number', 'ifsc_code', 'account_holder_name'];

        // Check if OCR actually captured all three required fields
        const ocrFoundAllFields = ocrSnapshot && requiredFields.every(field =>
            ocrSnapshot[field] && ocrSnapshot[field].toString().trim() !== ""
        );

        // Logic: Verified ONLY if OCR succeeded, found all 3 fields, and user didn't edit them
        if (vendorData.account_holder_name && vendorData.account_number && vendorData.ifsc_code && !doc.userModified) {
            return "Verified";
        }

        return "Not Verified";
    };

    return (
        <div className="vendor-card">
            <h3>Banking Information</h3>
            {/* UPLOAD SECTION - Two Columns */}
            <div className="two-col-grid">
                {/* PASSBOOK UPLOAD */}
                <div className="input-wrapper" style={{ width: '100%' }}>
                    <span className="input-label">Upload Passbook* (Any one required)</span>
                    <div className="input-with-icon-vendor-form" style={{ width: '100%', cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => !isDisabled && passbookRef.current?.click()}>
                        <input
                            type="text"
                            placeholder="Upload Passbook*"
                            readOnly
                            value={uploaded.passbook ? fileNames.passbook : ""}
                            disabled={isDisabled}
                            style={{ width: '100%' }} />

                        {uploaded.passbook ? (
                            <FaTimesCircle
                                className="remove-icon"
                                style={{ color: 'green' }}
                                onClick={(e) => { e.stopPropagation(); handleRemoveFile('passbook'); }}
                            />
                        ) : (
                            <FaUpload className="upload-icon" />
                        )}
                        <input
                            type="file"
                            ref={passbookRef}
                            style={{ display: 'none' }}
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={(e) => handleFileChange(e, 'passbook')}
                            disabled={isDisabled}
                        />
                    </div>
                    {/*  Verification Label */}
                    {uploaded.passbook && (
                        <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                fontSize: '12px',
                                fontWeight: 'bold',
                                color: getVerificationStatus("passbook") === "Verified" ? "green" : "red"
                            }}>
                                {getVerificationStatus("passbook")}
                            </div>

                            {/* <div>
                                <input
                                    type="checkbox"
                                    checked={verificationState.passbook.manuallyVerified}
                                    onChange={(e) =>
                                        setVerificationState(prev => ({
                                            ...prev,
                                            passbook: {
                                                ...prev.passbook,
                                                manuallyVerified: e.target.checked
                                            }
                                        }))
                                    }
                                />
                            </div> */}
                        </div>
                    )}
                    {/* Nested Bank Fields for Passbook */}
                    {uploaded.passbook && (
                        <div style={{ marginTop: '10px', width: '100%' }}>
                            <BankFields
                                vendorData={vendorData}
                                handleVendorChange={handleBankFieldChange}
                                isDisabled={isDisabled}
                                vendorOnboardInfo={vendorOnboardInfo}
                                isBankMandatory={isBankMandatory}
                            />
                        </div>
                    )}
                </div>

                {/* CANCELLED CHEQUE UPLOAD */}
                <div className="input-wrapper" style={{ width: '100%' }}>
                    <span className="input-label">Cancelled Cheque* (Any one required)</span>
                    <div className="input-with-icon-vendor-form" style={{ width: '100%', cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => !isDisabled && chequeRef.current?.click()}>
                        <input
                            type="text"
                            placeholder="Cancelled Cheque*"
                            readOnly
                            value={uploaded.cheque ? fileNames.cheque : ""}
                            disabled={isDisabled}
                            style={{ width: '100%' }}
                        />
                        {uploaded.cheque ? (
                            <FaTimesCircle
                                className="remove-icon"
                                style={{ color: 'green' }}
                                onClick={(e) => { e.stopPropagation(); handleRemoveFile('cheque'); }}
                            />
                        ) : (
                            <FaUpload className="upload-icon" />
                        )}
                        <input
                            type="file"
                            ref={chequeRef}
                            style={{ display: 'none' }}
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={(e) => handleFileChange(e, 'canceled_cheque')}
                            disabled={isDisabled}
                        />
                    </div>
                    {/* Verification label */}
                    {uploaded.cheque && (
                        <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                fontSize: '12px',
                                fontWeight: 'bold',
                                color: getVerificationStatus("passbook") === "Verified" ? "green" : "red"
                            }}>
                                {getVerificationStatus("passbook")}
                            </div>
                            <div>
                                {/* <input
                                    type="checkbox"
                                    checked={verificationState.cheque.manuallyVerified}
                                    onChange={(e) =>
                                        setVerificationState(prev => ({
                                            ...prev,
                                            cheque: {
                                                ...prev.cheque,
                                                manuallyVerified: e.target.checked
                                            }
                                        }))
                                    }
                                /> */}
                            </div>
                        </div>
                    )}
                    {/* Nested Bank Fields for Cheque */}
                    {uploaded.cheque && (
                        <div style={{ marginTop: '10px', width: '100%' }}>
                            <BankFields
                                vendorData={vendorData}
                                handleVendorChange={handleBankFieldChange}
                                isDisabled={isDisabled}
                                vendorOnboardInfo={vendorOnboardInfo}
                                isBankMandatory={isBankMandatory}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div >
    );
};
export default Step2_Bank;


